import React, { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { clearSignupProgress } from '../utils/signupProgress';
import { BRAND_NAME, BIG_LOGO_PATH } from '../config';
import { useSiteConfig } from '../utils/useSiteConfig';

function ThankYouPage() {
  const siteConfig = useSiteConfig();

  // Clear signup progress when thank you page loads (signup is complete)
  useEffect(() => {
    clearSignupProgress();
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        py: 4,
        px: 2
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          {/* Logo */}
          <Box sx={{ mb: 6 }}>
            <img
              src={BIG_LOGO_PATH}
              alt={BRAND_NAME}
              style={{
                maxWidth: '200px',
                height: 'auto',
                margin: '0 auto'
              }}
            />
          </Box>

          {/* Thank You Message */}
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              color: '#000000',
              lineHeight: 1.4,
              mb: 4,
              textAlign: 'center',
              whiteSpace: 'pre-line'
            }}
          >
            {siteConfig.thankYouMessage || (
              <>
                Thank you for
                <br />
                applying if you are
                <br />
                selected to create
                <br />
                content with us we
                <br />
                will email you.
              </>
            )}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default ThankYouPage;

